/* src/app/shared/components/forbidden/forbidden.component.scss */
.forbidden {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
/*# sourceMappingURL=forbidden.component.css.map */
